module.exports = __webpack_public_path__ + "images/7c327e43aadcc8c1c13df75e364f1ecb-sia-realtime-logo.svg";